export class BatchFunctionLogic {

    // TODO: comment this class

    queueDictionary: { [key: string]: (() => Promise<any>)[] };
    queueExecutingStatusDictionary: { [key: string]: boolean }; 

    constructor() {
        this.queueDictionary = {};
        this.queueExecutingStatusDictionary = {};
    }
    
    public addFunction(queueName: string, func: () => Promise<any>) {
        if(!(queueName in this.queueDictionary)) {
            this.queueDictionary[queueName] = [];
            this.queueExecutingStatusDictionary[queueName] = false;
        }

        this.queueDictionary[queueName].push(func);
    }

    public async startIfNeeded(queueName: string, queueSize: number = 5, waitTime: number = 500, calledByExecutingThread: boolean = false) {
        if(!this.queueDictionary) { 
            return;
        }

        if(!(queueName in this.queueDictionary)) return;
        if(queueName in this.queueExecutingStatusDictionary) {
            const isQueueAlreadyExecuting = this.queueExecutingStatusDictionary[queueName];
            if(isQueueAlreadyExecuting && !calledByExecutingThread) return;

            this.queueExecutingStatusDictionary[queueName] = true;
        }

        const functionsToExecute: (() => Promise<any>)[] = [];
        let currentFunction: undefined | (() => Promise<any>) = this.queueDictionary[queueName].shift();
        if(!currentFunction) {
            this.queueExecutingStatusDictionary[queueName] = false;
            return;
        } else {
            functionsToExecute.push(currentFunction);
        }

        do {
            currentFunction = this.queueDictionary[queueName].shift();
            if(currentFunction) functionsToExecute.push(currentFunction);
        } while(currentFunction && functionsToExecute.length < queueSize);

        for(let i = 0; i < functionsToExecute.length; i++) {
            try {
                await functionsToExecute[i]();
            } catch(error) {
                console.log(error);
            }
        }

        setTimeout(() => {
            BatchFunctionLogicSingleton.startIfNeeded(queueName, queueSize, waitTime, true);
        }, 500);
    }

    public clearQueue(queueName: string) {
        if(queueName in this.queueDictionary) {
            this.queueDictionary[queueName] = [];
            this.queueExecutingStatusDictionary[queueName] = false;
        }
    }
}

export const BatchFunctionLogicSingleton = new BatchFunctionLogic();